module.exports = "<div class=\"page-content\">\n  <h1 class=\"icon-faq\"> faq</h1>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/faq/faq.html
 ** module id = 469
 ** module chunks = 0
 **/